import React, { Component } from "react";

export default class TabList extends Component {
    render() {
        const p = this.props;
        const items = p.elems.filter(item => item.tabId === p.currentTabId).map((elem) =>
            <Tab key={elem.tabId} elems={elem.elems} />
        );
    return (
<React.Fragment>
    {items}
</React.Fragment>
        );
    }
}

function Tab(props) {
    return (
    <div className="instruction-header-message">
        <div>
            {renderHeader(props.elems)}
        </div>
    </div>
    );
}

function renderHeader(elems) {
    return elems.map(function (elem, index) {
        return renderItem(elem, index);
    });
}

function renderItem(elem, index) {
    switch (elem.type) {
    case "h1":
        return <h1 key={index}>{elem.text}</h1>;
    case "h2":
        return <h2 key={index}>{elem.text}</h2>;
    case "p":
        return <p key={index}>{elem.text}</p>;
    default:
        return null;
    }
}
